var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"areaMap"},[_c('a-card',{staticClass:"center-part-card"},[_c('div',{attrs:{"id":"centerContainer"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }